import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Container, ContainerContent, GoBack } from '@/component';
import ProjectCreateForm from '@/component/Project/ProjectCreateForm';
import { VFlex } from '@/package';
import { useMainLayout } from '@/provider/layout';

const ProjectCreaetPage = () => {
  const { t } = useTranslation();
  const { setTitle } = useMainLayout();

  useEffect(() => {
    setTitle(() => (
      <VFlex className="gap-[10px]">
        <GoBack to={'/project'} />
        {t('project.createProject.counterguard')}
      </VFlex>
    ));
  }, []);

  return (
    <Container>
      <ContainerContent>
        <VFlex justify="center" className="w-full pt-16">
          <ProjectCreateForm />
        </VFlex>
      </ContainerContent>
    </Container>
  );
};

export default ProjectCreaetPage;
